import React from 'react'

interface IProps {}

const QuestionDetail: React.FC<IProps> = () => {
  return <>It will be released soon!</>
}

export default QuestionDetail
